(function ($) {
  Drupal.behaviors.filterTabPanelFormatterV1 = {
    attach: function (context) {
      var self = this;
      var $modules = $('.js-filter-tab-panel-formatter', context);

      $modules.each(function () {
        var $module = $(this);
        var $tabs = $module.find('.js-filter-tab-panel-formatter__tabs');
        var $contents = $module.find('.js-filter-tab-panel-formatter__contents');
        var $items = $contents.find('.js-filter-tab-panel-formatter__contents-item');

        $items.first().addClass('active');
        if ($tabs && $tabs.length > 0) {
          self.generateTabs($tabs);
          self.setListeners($tabs, $items);
        }
      });
    },
    setListeners: function ($tabs, $items) {
      var $tab;
      var $tabItems = $tabs.find('.js-filter-tab-panel-formatter__tabs-item');

      $tabItems.off('click.tab').on('click.tab', function () {
        $tab = $(this);
        $tabItems.removeClass('active');
        $tab.addClass('active');
        $items.removeClass('active');
        $items.eq(Number($tab.data('tabIndex'))).addClass('active');
      });
    },
    generateTabs: function ($tabs) {
      var tabList = $tabs.data('filterTitles');
      var $scroller = $tabs.find('.js-filter-tab-panel-formatter__tabs-scroller');
      var tabArray = [];
      var activityClass;
      var i;

      if (tabList) {
        tabArray = tabList.split(',');
        for (i = 0; i < tabArray.length; i++) {
          activityClass = '';
          if (i === 0) {
            activityClass = 'active';
          }
          $scroller.append($('<div class="filter-tab-panel-formatter__tabs-item js-filter-tab-panel-formatter__tabs-item ' + activityClass + '" data-tab-index="' + i + '">' + tabArray[i] + '</div>'));
        }
        $tabs.children().first().addClass('active');
      }
    }
  };
})(jQuery);
